import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { borderRadius, breakpoint, fontSize, size } from '@twisto/styles'

export const input = (theme: Theme) => css`
  display: grid;
  position: relative;
  align-items: center;
  justify-items: center;
  width: 100%;
  height: ${size[48]};
  background-color: ${theme.palette.neutral[200]};
  border-radius: ${borderRadius.sm};
  border: none;
  text-align: center;
  padding: ${size[0]} ${size[16]};
  font-weight: 700;
  font-size: ${fontSize.sm};
  color: ${theme.palette.neutral[900]};

  ${breakpoint.up('md')} {
    font-size: ${fontSize.smMd};
    padding: ${size[0]} ${size[24]};
  }
`

export const disabled = (theme: Theme) => css`
  color: ${theme.palette.neutral[600]};
  cursor: not-allowed;
`
